import {
    SEARCH_AUDIT_LOGS,
    GET_AUDIT_LOG_DETAIL,
    ROLLBACK_AUDIT_LOG,
    GET_AUDIT_LOG_MODELS
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    audit_logs: {
        logs: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    log_detail: null,
    rollback_result: null,
    model_options: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SEARCH_AUDIT_LOGS: {
            return {
                ...state,
                audit_logs: {
                    logs: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    }
                }
            };
        }

        case GET_AUDIT_LOG_DETAIL: {
            return {
                ...state,
                log_detail: action.payload || null
            };
        }

        case ROLLBACK_AUDIT_LOG: {
            return {
                ...state,
                rollback_result: action.payload || null
            };
        }

        case GET_AUDIT_LOG_MODELS:
            return {
                ...state,
                model_options: action.payload.data || []
            };

        default:
            return { ...state };
    }
};
